import React, { useState } from 'react';

// Password field with a show/hide toggle. Owns its own visibility state;
// everything else (value, validation, autoComplete, etc.) is passed through.
export default function PasswordInput({ value, onChange, inputStyle, ...inputProps }) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div style={styles.wrap}>
      <input
        type={showPassword ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        style={{ ...styles.input, ...inputStyle }}
        {...inputProps}
      />
      <button
        type="button"
        onClick={() => setShowPassword((v) => !v)}
        style={styles.eyeBtn}
        aria-label={showPassword ? 'Hide password' : 'Show password'}
      >
        {showPassword ? (
          // Eye with slash
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
            <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
            <line x1="1" y1="1" x2="23" y2="23"/>
          </svg>
        ) : (
          // Eye open
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
            <circle cx="12" cy="12" r="3"/>
          </svg>
        )}
      </button>
    </div>
  );
}

const styles = {
  wrap: { position: 'relative', display: 'flex', alignItems: 'center' },
  input: {
    flex: 1, padding: '10px 40px 10px 12px',
    border: '1px solid #d9d4c5', borderRadius: '8px',
    fontSize: '15px', color: '#1a1a2e', backgroundColor: '#fff', outline: 'none',
  },
  eyeBtn: {
    position: 'absolute', right: '10px',
    background: 'none', border: 'none', cursor: 'pointer',
    fontSize: '16px', padding: '0', lineHeight: '1', display: 'flex', alignItems: 'center',
  },
};
